export const translations = {
  title: {
    pt: 'Prévia de pedágio',
    en: 'Toll Preview',
    es: 'Vista previa del peaje',
    de: 'Mautvorschau',
  },
  distance: {
    pt: 'Distância',
    en: 'Distance',
    es: 'Distancia',
    de: 'Entfernung',
  },
  duration: {
    pt: 'Tempo',
    en: 'Time',
    es: 'Tiempo',
    de: 'Zeit',
  },
  order: {
    pt: 'Ordem',
    en: 'Order',
    es: 'Orden',
    de: 'Reihenfolge',
  },
  place: {
    pt: 'Praça',
    en: 'Plaza',
    es: 'Plaza',
    de: 'Platz',
  },
  value: {
    pt: 'Valor',
    en: 'Value',
    es: 'Valor',
    de: 'Wert',
  },
  emptyTollsListMessage: {
    pt: 'O trajeto não possui pedágios',
    en: 'The route does not have tolls',
    es: 'El trayecto no tiene peajes',
    de: 'Der Weg hat keine Mauten',
  }
};